<footer class="bg-sem-surface-default pl-16 pr-[60px] py-2 text-sm text-sem-content-secondary shadow-[0_-1px_3px_0_rgb(0_0_0/0.1),0_-1px_2px_-1px_rgb(0_0_0/0.1)]">
  <div class="flex flex-wrap items-center justify-between gap-2">
    <div class="order-2 flex items-center gap-3 min-[768px]:order-1">
      <span>v{{ version }}</span>
      <span>&copy; {{ copyRightYear }} J.D. Irving. </span>
      <span i18n="@@footerAllRightsReservedLabel">All Rights Reserved.</span>
    </div>

    <div class="order-1 flex items-center gap-3 min-[768px]:order-2">
      @if (privacyPolicyURL) {
        <a
          class="text-sem-content-secondary no-underline hover:text-sem-content-primary"
          [href]="privacyPolicyURL"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span i18n="@@footerPrivacyPolicyLabel">Privacy Policy</span>
        </a>
      }
      @if (termsAndConditionsURL) {
        <a
          class="text-sem-content-secondary no-underline hover:text-sem-content-primary"
          [href]="termsAndConditionsURL"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span i18n="@@footerTermsOfUseLabel">Terms of Use</span>
        </a>
      }
      @if (cookieConsentService.isEnabled) {
        <button
          class="ot-sdk-show-settings text-sem-content-secondary hover:text-sem-content-primary"
          type="button"
          (click)="openCookieSettings()"
          i18n="@@footerCookieSettingsLabel"
        >
          Cookie Settings
        </button>
      }
    </div>
  </div>
</footer>
